'use strict';

var TAB = '\t';
exports.TAB = TAB;
var ENTER = '\n';
exports.ENTER = ENTER;
var SPACE = ' ';
exports.SPACE = SPACE;


//////////////////
// WEBPACK FOOTER
// ./node_modules/mobiledoc-kit/dist/commonjs/mobiledoc-kit/utils/characters.js
// module id = 316
// module chunks = 0